import PropTypes from 'prop-types';

import { branch, compose, lifecycle, renderComponent } from 'recompose';

import { ErrorBoundaryView } from './ErrorBoundary.view';
import { Logger } from '../../../src/common/logger';

const defaultErrorLogger = (error, info) =>
    Logger.info('Logging error from ErrorBoundary: ', error, info);

const showErrorBoundary = compose(
    lifecycle({
        componentDidCatch(error, info) {
            const { errorLogger } = this.props;
            this.setState({ error, info });
            errorLogger({ error });
        },
    }),
    branch(({ error }) => error, renderComponent(ErrorBoundaryView))
);

export const ErrorBoundary = compose(showErrorBoundary)(({ children }) => children);

ErrorBoundary.displayName = 'ErrorBoundary';
ErrorBoundary.propTypes = {
    errorLogger: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
};

ErrorBoundary.defaultProps = {
    errorLogger: defaultErrorLogger,
    errorMessage: 'Unable to display component. Please check error in console.',
};
